// extracted by mini-css-extract-plugin
module.exports = {"container":"Article_container__M5qpB","content":"Article_content__3dwuT","heading":"Article_heading__jTSc2","paragraph":"Article_paragraph___Y5HT","list":"Article_list__F7_HS"};